import moment from "moment";
import { MaskAadhaar } from "../CommonFunctions/CommonFunction";

export const AbstractColumns = [
  { Header: "S.NO", accessor: (row, index) => index + 1 },
  { Header: () => "Candidate ID", accessor: "candidate_id" },
  { Header: "Aadhaar", accessor: (row) => (<>{MaskAadhaar(row?.aadhaar_no)}</>) },
  { Header: "Mobile", accessor: 'mobile_no' },
  { Header: () => "Candidate Name", accessor: "applicant_name" },
  { Header: () => "Father Name", accessor: "father_name" },
  {
    Header: "DOB", id: "dob",
    accessor: (row) => {
      if (!row?.dob) return "";
      const date = moment(row.dob, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY"], true);
      return date.isValid() ? date.format("DD/MM/YYYY") : row.dob;
    }
  },
  { Header: () => "Gender", accessor: "gender" },
  { Header: () => "PH", accessor: "ph" },
  { Header: "Post Applied", accessor: (row) => <>{row?.posts}</> },
]
export const getCommonColumns = ({
  getCandidateAbstractData,
  setLabelName,
  setTypeName,
  setDrillCount,
  rowIdentifierKey,
  labelFormatter,
  labelFormatFunc = (val) => val,
  labelTitle = 'Label',
}) => {
  const getCellClickHandler = (row, type, mode) => () => {
    getCandidateAbstractData(
      row?.original?.[rowIdentifierKey],
      type,
      rowIdentifierKey === 'dist_name' ? row?.original?.dist_code : "0",
      mode
    );
    setLabelName(labelFormatFunc(row?.original?.[rowIdentifierKey]));
    setTypeName(getTypeLabel(type));
    setDrillCount(1);
  };

  const getFooterClickHandler = (type, mode) => () => {
    getCandidateAbstractData("0", type, 0, mode);
    setLabelName('');
    setTypeName(getTypeLabel(type));
    setDrillCount(1);
  };

  const renderClickableCell = (field, type, mode) => ({
    row
  }) => (
    <button className="btn btn-link"
      style={{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: 'blue',
        textAlign: 'right'
      }}
      onClick={getCellClickHandler(row, type, mode)}
    >
      {row?.original?.[field]}
    </button>
  );


  const getTypeLabel = (typeCode) => {
    switch (typeCode) {
      case "T":
        return "Application Started";
      case "C":
        return "Application Completed";
      case "0":
        return "Total Posts Applied";
      default:
        return "";
    }
  };

  const getMode = (typeCode) => {
    if (rowIdentifierKey === 'dist_name') {
      return typeCode === "0" ? "DIP" : "DIC";
    } else {
      return typeCode === "0" ? "DP" : "DC";
    }
  };

  return [
    {
      Header: "S.NO",
      accessor: (row, index) => index + 1,
      Footer: "Total"
    },
    {
      Header: () => labelTitle,
      accessor: rowIdentifierKey
    },
    {
      Header: "Application Started",
      accessor: "total_candidates",
      Cell: renderClickableCell("total_candidates", "T", getMode("T")),
      Footer: "total_candidates",
      FooterFunc: getFooterClickHandler("T", getMode("T")),
      isClickable: true
    },
    {
      Header: "Application Completed",
      accessor: "application_completed",
      Cell: renderClickableCell("application_completed", "C", getMode("C")),
      Footer: "application_completed",
      FooterFunc: getFooterClickHandler("C", getMode("C")),
      isClickable: true
    },
    {
      Header: "Total Posts Applied",
      accessor: "tot_posts_applied",
      Cell: renderClickableCell("tot_posts_applied", "0", getMode("0")),
      Footer: "tot_posts_applied",
      FooterFunc: getFooterClickHandler("0", getMode("0")),
      isClickable: true
    },
    // {
    //   Header: () => "Posts Paid in 2025",
    //   accessor: "posts_paid_in_2025",
    //   Footer: "posts_paid_in_2025"
    // },
    // {
    //   Header: () => "Posts Paid in 2024",
    //   accessor: "posts_paid_in_2024",
    //   Footer: "posts_paid_in_2024"
    // }
  ];
};
